import { render, staticRenderFns } from "./Accordions.vue?vue&type=template&id=c2c6685a&"
import script from "./Accordions.vue?vue&type=script&lang=js&"
export * from "./Accordions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports